"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorBoundary = void 0;
var react_1 = __importDefault(require("react"));
var BlockCrash_1 = require("Project/QwilrEditor/BlockCrash");
var ErrorBoundary = (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.renderBlockCrashModal = function () {
            var modal = _this.props.modal;
            modal.showSimpleModal({
                isEscapable: false,
                containerClassName: "block-crashed-modal",
                body: react_1.default.createElement(BlockCrash_1.BlockCrash, { explanationText: "Something went wrong displaying a block on this page" }),
            });
        };
        _this.errorRecorder = props.errorRecorder;
        return _this;
    }
    ErrorBoundary.prototype.componentDidCatch = function (error, info) {
        var componentStack = info.componentStack;
        this.errorRecorder.recordError(error, { componentStack: componentStack }, { editorExceptionCategory: "errorBoundary" });
        return this.renderBlockCrashModal();
    };
    ErrorBoundary.prototype.render = function () {
        return this.props.children;
    };
    return ErrorBoundary;
}(react_1.default.Component));
exports.ErrorBoundary = ErrorBoundary;
